import { menusApi } from "@apiService";
import * as types from "./types";

export const getMenus = (slug) => {
  return {
    type: types.GET_MENUS,
    payload: menusApi.getMenu(slug),
  };
};
